import React, { useEffect, useState } from "react";
import { Col, Form, Row, Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaInput } from "apps/Common/MazakaInput";
import useMazakaForm from "hooks/useMazakaForm";
import { useDebouncedCallback } from "use-debounce";
import { LoadingOutlined } from "@ant-design/icons";

import { getIETTSInfoes, getTTBSInfoes } from "../Services";
import { useDispatch, useSelector } from "react-redux";
import {
  handleSetDoneSteps,
  handleSetinstitutionalStoreInfoes,
} from "../ClientSideStates";
import { useSearchParams } from "react-router-dom";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { RootState } from "store/Reducers";

const VerifyInfoes = ({
  setCurrentStep,
}: {
  setCurrentStep: (step: number) => void;
}) => {
  const [form] = Form.useForm();
  const { formActions } = useMazakaForm(form);
  const { Text } = Typography;
  const [searchParasm, setSearchParams] = useSearchParams();
  const storeId = searchParasm.get("storeId");
  const {userInfoes} = useSelector((state:RootState)=>state.profile)
  const {initialStoreInfoes} =useSelector((state:RootState)=>state.institutional)
  const dispatch = useDispatch();

  const [validationState, setValidationState] = useState<any>({
    TTBSNO: { isLoading: false, isValid: null },
    IETTSNo: { isLoading: false, isValid: null },
  });

  const validateField = async (fieldName: string, value: string) => {
    const validators: Record<string, (value: string) => Promise<boolean>> = {
      TTBSNO: async (val) => {
        try {
          const response: any = await getTTBSInfoes({ belgeNo: val });
          if ( response?.data?.yetkiBelgesiNumarasi?.length>0
          ) {
            openNotificationWithIcon("default","Firma bilgileri başarıyla alındı")
            const data = { ...response.data, TTBSNO: val };
          dispatch(handleSetinstitutionalStoreInfoes({ data }));
            dispatch(
              handleSetinstitutionalStoreInfoes({ data })
            );
          }
          else{
            dispatch(
              handleSetinstitutionalStoreInfoes({ data: null})
            );
          }
          return  response?.data?.yetkiBelgesiNumarasi?.length>0
        } catch (error) {
          console.error(error);
          return false;
        }
      },
      IETTSNo: async (val) => {
        try {
          const response: any = await getIETTSInfoes({ belgeNo: val });
          if ( response?.data?.yetkiBelgesiNumarasi?.length>0) {
            openNotificationWithIcon("default","Firma bilgileri başarıyla alındıπ")
            const data = { ...response.data, IETTSNo: val };
          dispatch(handleSetinstitutionalStoreInfoes({ data }));
            dispatch(
              handleSetinstitutionalStoreInfoes({ data: response.data })
            );
          }
          else{
            dispatch(
              handleSetinstitutionalStoreInfoes({ data: null})
            );
          }
          return response?.data?.yetkiBelgesiNumarasi?.length>0
        } catch (error) {
          console.error(error);
          return false;
        }
      },
    };

    setValidationState((prev: any) => ({
      ...prev,
      [fieldName]: { isLoading: true, isValid: null },
    }));

    const isValid = await validators[fieldName](value);

    setValidationState((prev: any) => ({
      ...prev,
      [fieldName]: { isLoading: false, isValid },
    }));
  };

  const handleDebouncedChange = useDebouncedCallback(
    (fieldName: string, value: string) => {
      validateField(fieldName, value);
    },
    1000
  );

  const isFormValid = Object.values(validationState).some(
    (state: any) => state.isValid === true
  );

  const handleOnFinish = () => {
    setCurrentStep(1);

    dispatch(handleSetDoneSteps({ data: [0] }));
  };

  useEffect(()=>{
   form.setFieldsValue({...initialStoreInfoes})
  },[initialStoreInfoes])

  return (
    <Col span={24}>
      <MazakaForm
        submitButtonVisible={false}
        form={form}
        onFinish={handleOnFinish}
      >
        
        <Row gutter={[10, 20]} className="">
          <Col xs={24} className="  !rounded-md">
            <Text className="!text-black !text-xs md:!text-lg">
            {`Sayın ${(userInfoes?.name && userInfoes?.surname) ? `${userInfoes.name} ${userInfoes.surname}` : "Kullanıcı"}, en kârlı satış ve yatırım fırsatları için en doğru tercihi yaptınız. Aramıza hoş geldiniz! Şimdi sadece birkaç doğrulama adımı kaldı.`}


            </Text>
          </Col>

          {["TTBSNO", "IETTSNo"].map((field) => (
            <Col xs={24} key={field}>
              <Row gutter={[0, 5]}>
                <MazakaInput
                  xs={24}
                  name={field}
                  label={
                    field === "TTBSNO"
                      ? "TTBS NO (Emlak Numarası)"
                      : "İETTS No (Taşıt Ticaret Numarası)"
                  }
                  className="!m-0"
                  inputClassName="!bg-[#f7f7f7] !p-2"
                  placeholder={
                    field === "TTBSNO"
                      ? "TTBS NO (Emlak Numarası)"
                      : "İETTS No (Taşıt Ticaret Numarası)"
                  }
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const value = e.target.value;
                    if (value) {
                      handleDebouncedChange(field, value);
                    } else {
                      // filed TTBSNO ise o isValidi Null degilse IETSSNo is vald null olsun
                    }
                  }}
                  disabled={validationState[field].isLoading}
                  suffix={
                    validationState[field].isLoading ? (
                      <LoadingOutlined />
                    ) : null
                  }
                />
                {validationState[field].isValid === false && (
                  <Col xs={24}>
                    <Text className="!text-red-500 !text-xs">
                      Numara geçerli değil
                    </Text>
                  </Col>
                )}
              </Row>
            </Col>
          ))}
          <Col span={24} className="!flex gap-2 items-end md:items-start">
            <MazakaButton
              className={`!p-4 !bg-[#FFC502] !text-black !mt-4 ${storeId?"":"!w-full md:!max-w-auto"}  `}
              htmlType="submit"
              processType={formActions.submitProcessType}
              disabled={!isFormValid}
            >
              Kaydet ve Devam Et
            </MazakaButton>
            {storeId && (
              <>
                <MazakaButton
                  processType={formActions.submitProcessType}
                
                  className="!p-4 !bg-black !text-white"
                  htmlType="submit"

                  onClick={() => {
                    setCurrentStep(2);

                    dispatch(handleSetDoneSteps({ data: [0, 1] }));
                  }}
                >
                  Devam Et
                </MazakaButton>
              </>
            )}
          </Col>

         
        </Row>
      </MazakaForm>
    </Col>
  );
};

export default VerifyInfoes;
